import { Form, Input, Modal, Spin } from 'antd';
import React, { Component } from 'react';
import '../style.css';

class AlertForm extends Component {
  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form } = this.props;

    if (d && d.keyword !== pd.keyword) form.setFieldsValue(d);
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    form.resetFields();
    onCancel();
  };

  render() {
    const { visible, onCreate, form, flagCreateOrUpdateForm, loading } = this.props;
    const { getFieldDecorator } = form;
    const okText = flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
    const title = `${okText} Alert keyword`;

    return (
      <Modal
        cancelText="ยกเลิก"
        maskClosable={false}
        okText={okText}
        onCancel={this.handleCancelModal}
        onOk={onCreate}
        style={{ top: 20 }}
        title={title}
        visible={visible}
      >
        <Spin spinning={loading} tip="กำลังบันทึกข้อมูล...">
          <Form className="alert_form">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            <Form.Item label="Keyword">
              {getFieldDecorator('keyword', {
                rules: [
                  {
                    message: 'กรุณากรอก Alert Keyword ที่ต้องการ',
                    required: true,
                  },
                ],
              })(<Input />)}
            </Form.Item>
            {/* <div className="note">
              <span className="focus">หมายเหตุ</span>: ถ้าต้องการให้ตรวจสอบมากกว่า 1
              คำในข้อความ ให้ใส่ , (comma) คั่นระหว่างคำ เช่น หวย,พนัน เป็นต้น
            </div> */}
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: 'alert_form' })(AlertForm);



// WEBPACK FOOTER //
// ./src/containers/Keyword/Alert/form.js